import React, { useContext } from 'react';
import { NavLink } from "react-router-dom";
import styles from './OglasiNav.module.css';
import { ThemeContext } from '../contexts/ThemeContext';

const OglasiNav = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <ul className={dark ? styles.oglasiNavDark : styles.oglasiNavLight}>
      <li><NavLink
        to="/oglasi/godina/1"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Prva godina</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/2"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Druga godina</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/3"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Treća godina</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/4"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Četvrta godina</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/20"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Drugi ciklus</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/30"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Treći ciklus</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/102"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Postdiplomski studij</NavLink></li>
      <li><NavLink
        to="/oglasi/godina/21"
        className={dark ? styles.oglasiNavLiDark : styles.oglasiNavLiLight}
        activeClassName={dark ? styles.oglasiNavLiActiveDark : styles.oglasiNavLiActiveLight}
      >Odbrane završnih radova</NavLink></li>
    </ul>
  );
}

export default OglasiNav;